export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_APPEALS_API_URL: import.meta.env.VITE_APPEALS_API_URL,
  // The agents service through the CRM UI proxy, prefix kept (GSB-7591)
  // The agents service behind this app's own origin (GSB-7594); the container env carries no FE_AGENTS_API_URL, so default it (GSB-7700).
  VITE_AGENTS_API_URL: import.meta.env.VITE_AGENTS_API_URL ?? '/agents',
  VITE_WORKFLOWS_API_URL: import.meta.env.VITE_WORKFLOWS_API_URL,
  // The Workflows API (Gasbi.Workflows.Api) the workflow builder reads and saves definitions through,
  // behind this app's own origin; defaulted like the agents url, for a container env without the FE_ var.
  VITE_WORKFLOW_DEFINITIONS_API_URL:
    import.meta.env.VITE_WORKFLOW_DEFINITIONS_API_URL ??
    '/workflow-definitions-api',
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_SUPPLY_SYSTEM_URL: import.meta.env.VITE_SUPPLY_SYSTEM_URL,
  VITE_SUPPLY_SYSTEM_FINANCE_URL: import.meta.env
    .VITE_SUPPLY_SYSTEM_FINANCE_URL,
  VITE_ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  // The product group this CRM serves (GSB-8397): unset for Supply's CRM, 'distribution' for the
  // Distribution group's CRM, which links that group's apps instead of Supply's (VITE_ADMIN_URL is
  // then Distribution Admin).
  VITE_PRODUCT_GROUP: import.meta.env.VITE_PRODUCT_GROUP,
  VITE_BMS_URL: import.meta.env.VITE_BMS_URL,
  VITE_HOUSEHOLDS_URL: import.meta.env.VITE_HOUSEHOLDS_URL,
};
